import { createIcon } from "@chakra-ui/react";

export const Pause = createIcon({
  displayName: "Pause",
  viewBox: "0 0 24 24",
  path: [
    <g transform="translate(4, 4)">
      <path
        fill="currentColor"
        d="M3.5 1C2.67 1 2 1.672 2 2.5v11c0 .828.67 1.5 1.5 1.5h1.5c.83 0 1.5-.672 1.5-1.5v-11C6.5 1.672 5.83 1 5 1H3.5zm7 0c-.83 0-1.5.672-1.5 1.5v11c0 .828.67 1.5 1.5 1.5H12c.83 0 1.5-.672 1.5-1.5v-11c0-.828-.67-1.5-1.5-1.5h-1.5z"
      />
    </g>
  ],
  defaultProps: {
    "aria-label": "A pause symbol"
  }
});

export default Pause;
